export enum AuthorityKits {
  KITS_VIEW = '1.17.1',
  KITS_REGISTRATION = '1.17',
  KITS_DELETE = '1.17.3',
  KITS_EDIT = '1.17.4',
  KITS_CHANGE_PRICES = '1.17.6',
}
